import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyC5HDeF3_tpTpcCv_hgBTMa7i5tXXXt4zs",
  authDomain: "stocks-8967e.firebaseapp.com",
  databaseURL: "https://stocks-8967e.firebaseio.com",
  projectId: "stocks-8967e",
  storageBucket: "stocks-8967e.appspot.com",
  messagingSenderId: "262852767383"
}

firebase.initializeApp(config)

export const ref = firebase.database().ref()
export const firebaseDb = firebase.database()
export const firebaseAuth = firebase.auth



// WEBPACK FOOTER //
// ./src/config/constants.js